import * as React from "react";
import styled, { css } from "styled-components";
import { Collapse } from "@mantine/core";
import useDisclosure from "util/hooks/useDisclosure";
import IconButton from "./IconButton";
const Container = styled.div(
  ({ $collapsible, $opened, theme }) => css`
    background-color: ${theme.colors.section.filled.background};
    border: 1px solid ${theme.colors.section.filled.border};
    border-radius: 10px;
    padding: ${$collapsible && !$opened ? 0 : theme.spacings.md};
    margin-bottom: ${theme.spacings.xxs};
  `
);
const Header = styled.div(
  ({ $collapsible, $opened, theme }) => css`
    display: flex;
    justify-content: space-between;
    gap: ${theme.spacings.xs};
    align-items: center;
    border-radius: 10px;
    padding: ${$collapsible && !$opened ? theme.spacings.md : 0};
    flex-wrap: wrap;

    &:hover {
      background-color: ${$collapsible && !$opened ? theme.colors.table.row.backgroundHover : "initial"};
    }
  `
);
const FlexWrapper = styled.div(
  ({ theme }) => css`
    display: flex;
    justify-content: flex-start;
    gap: ${theme.spacings.sm};
    align-items: center;
  `
);
const Section = ({
  title,
  titleAs: TitleAs = "h2",
  header = null,
  actions = null,
  preHeaderSection = null,
  headerLeftSection = null,
  collapsible = false,
  defaultClosed = false,
  onCollapse = () => {
  },
  disableCollapseButton = false,
  collapseButtonPosition = "left",
  children = null,
  className = void 0
}) => {
  const [opened, { toggle }] = useDisclosure(!defaultClosed);
  const onToggle = () => {
    toggle();
    onCollapse(opened);
  };
  const onHeaderClick = () => !disableCollapseButton && onToggle();
  const collapseButton = collapsible && /* @__PURE__ */ React.createElement(
    IconButton,
    {
      "data-testid": "collapseButton",
      title: `Toggle ${title.toLowerCase()} section`,
      onClick: (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (!disableCollapseButton) {
          onToggle();
        }
      },
      disabled: disableCollapseButton,
      name: opened ? "keyboard_arrow_up" : "keyboard_arrow_down",
      size: "lg"
    }
  );
  return /* @__PURE__ */ React.createElement(Container, { $opened: opened, $collapsible: collapsible, className }, /* @__PURE__ */ React.createElement(Header, { $opened: opened, $collapsible: collapsible, onClick: onHeaderClick }, /* @__PURE__ */ React.createElement(FlexWrapper, null, collapseButtonPosition === "left" && collapseButton, preHeaderSection && /* @__PURE__ */ React.createElement(
    FlexWrapper,
    {
      onClick: (e) => {
        e.stopPropagation();
      }
    },
    preHeaderSection
  ), /* @__PURE__ */ React.createElement(TitleAs, null, header != null ? header : title), headerLeftSection && /* @__PURE__ */ React.createElement(
    FlexWrapper,
    {
      onClick: (e) => {
        e.stopPropagation();
      }
    },
    headerLeftSection
  )), /* @__PURE__ */ React.createElement(FlexWrapper, null, actions && // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
  /* @__PURE__ */ React.createElement(
    "div",
    {
      onClick: (e) => {
        e.stopPropagation();
      }
    },
    actions
  ), collapseButtonPosition === "right" && collapseButton)), !collapsible && children, collapsible && /* @__PURE__ */ React.createElement(Collapse, { in: opened }, children));
};
export default Section;
